// CDC's county record, counted per state. The table is generated (see
// scripts/gen-state-tick-tally.ts) so pages that only need the counts never load the
// county list or CDC's FIPS lists.
import { STATE_TICK_TALLY } from "./geo/state-tick-tally";

export interface StateTickTally {
  established: number;
  reported: number;
  /** Every county (or parish, or independent city) in the state. */
  total: number;
}

export function stateTickTally(stateAbbr: string): StateTickTally {
  const [established, reported, total] = STATE_TICK_TALLY[stateAbbr.toUpperCase()] ?? [0, 0, 0];
  return { established, reported, total };
}

/**
 * The whole country: counties CDC lists as established or reported, how many states
 * (not counting D.C.) have at least one established county, and whether D.C. does.
 */
export function nationalTickTally(): StateTickTally & { states: number; dc: boolean } {
  let established = 0;
  let reported = 0;
  let total = 0;
  let states = 0;
  for (const [abbr, [e, r, t]] of Object.entries(STATE_TICK_TALLY)) {
    established += e;
    reported += r;
    total += t;
    if (e > 0 && abbr !== "DC") states++;
  }
  return { established, reported, total, states, dc: (STATE_TICK_TALLY.DC?.[0] ?? 0) > 0 };
}
